module.exports = __webpack_public_path__ + "images/2b0cc54e031aae16b108f090bf9c9ec0.svg";